import { render, staticRenderFns } from "./v-editor.vue?vue&type=template&id=5cc122d6&"
import script from "./v-editor.vue?vue&type=script&lang=js&"
export * from "./v-editor.vue?vue&type=script&lang=js&"
import style0 from "./v-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports